import AccessTimeIcon from '@mui/icons-material/AccessTime'
import InfoIcon from '@mui/icons-material/Info'
import { Tooltip } from '@mui/material'
import moment from 'moment'
import { selectIsUserAdmin } from '@authed/selectors'
import { useAppSelector } from '@redux/hooks'
import * as css from './styles'
import { GridFooterProps } from './types'
import { t } from '@lingui/core/macro'

const TOOLTIP_MESSAGE = 'The amount of visible rows may be limited, based on your permissions'

const LastSavedText = ({ updatedAt }) =>
  updatedAt ? (
    <p style={{ color: '#0000008A' }}>
      {t`Last updated:`}
      {moment.utc(updatedAt).local().format('lll')}
    </p>
  ) : null

export function GridFooter({
  datasetId,
  displayedRowsCount = 0,
  allRowsCount,
  selectedRows = [],
  isEditing = false,
  hideUpdatedAt = false,
}: GridFooterProps) {
  const meta = useAppSelector(state => state.Datasets.datasetMetadataById[datasetId])
  const userIsAdmin = useAppSelector(selectIsUserAdmin)

  const shouldShowSelectedRows = selectedRows.length > 0
  const allAvailableRowsCount = allRowsCount || meta?.count
  const shouldShowPermissionsTooltip = !userIsAdmin

  if (!allAvailableRowsCount && !displayedRowsCount) return null

  return (
    <css.Wrapper>
      <css.RowsInfo>
        <strong style={{ margin: 0, color: '#0000008A' }}>
          {isEditing ? 'Editing ' : 'Displaying '}
          {displayedRowsCount || allAvailableRowsCount} {t`of`}{' '}
          {displayedRowsCount > allAvailableRowsCount ? displayedRowsCount : allAvailableRowsCount}{' '}
          {t`rows`}
          {shouldShowSelectedRows ? ` - ${selectedRows.length} Selected` : null}
        </strong>
        {shouldShowPermissionsTooltip ? (
          <Tooltip title={TOOLTIP_MESSAGE} placement="top" enterDelay={100}>
            <InfoIcon style={{ color: '#0000008A', width: 17, height: 17, marginBottom: 2 }} />
          </Tooltip>
        ) : null}
      </css.RowsInfo>
      {hideUpdatedAt ? null : (
        <css.LastUpdatedWrapper>
          <AccessTimeIcon style={{ color: '#0000008A', width: 17, height: 17, marginBottom: 2 }} />
          <div className="grid-footer-updated-at">
            <LastSavedText updatedAt={meta?.updated_at} />
          </div>
        </css.LastUpdatedWrapper>
      )}
    </css.Wrapper>
  )
}
